import { lazy } from "react";
import HomeLayout from "src/layouts/HomeLayout";
import LoginLayout from "./layouts/LoginLayout";
import DashboardLayout from "./layouts/DashboardLayout";

export const routes = [
  {
    exact: true,
    path: "/",
    layout: LoginLayout,
    Guard: false,
    component: lazy(() => import("src/views/auth/login/Login")),
  },
  {
    exact: true,
    path: "/login",
    layout: LoginLayout,
    Guard: false,
    component: lazy(() => import("src/views/auth/login/Login")),
  },
  {
    exact: true,
    path: "/react/login",
    layout: LoginLayout,
    Guard: false,
    component: lazy(() => import("src/views/auth/login/Login")),
  },
  {
    exact: true,
    path: "/DataTable",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/DataTable")),
  },
  {
    exact: true,
    path: "/About",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/About")),
  },
  {
    exact: true,
    path: "/dashboard",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/views/Dashboard/Dashboard")),
  },
  {
    exact: true,
    path: "/dashboard/:prefix/:userId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/views/Dashboard/Dashboard")),
  },
  {
    exact: true,
    path: "/new_sales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/NewSales")),
  },
  {
    exact: true,
    path: "/order_history",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/OrderHistory")),
  },
  {
    exact: true,
    path: "/create_manifest",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/CreateManifest")),
  },
  {
    exact: true,
    path: "/route_planing_invoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/RoutePlaningInvoice")),
  },
  {
    exact: true,
    path: "/manifest_list",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/ManifestList")),
  },
  {
    exact: true,
    path: "/manifest_list/ManifestPrint/:manifestId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dispatch/ManifestPrint")),
  },
  {
    exact: true,
    path: "/manifest_list/mark_delivery/:manifestId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/NewMarkDelivery")),
  },
  {
    exact: true,
    path: "/demoModal/:manifestId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/ModalComponent")),
  },
  {
    exact: true,
    path: "/open_trips",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/OpenTrips")),
  },
  {
    exact: true,
    path: "/open_trips/trip_summary/:tripId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/OpenTripSummary")),
  },
  {
    exact: true,
    path: "/complete_trips",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/CompleteTrips")),
  },
  {
    exact: true,
    path: "/complete_trips/closed_trip_summary/:tripId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/CloseTripSummary")),
  },
  {
    exact: true,
    path: "/closed_trip_summary",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/ClosedTripSummary")),
  },
  {
    exact: true,
    path: "/return_list",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Return/ReturnList")),
  },
  {
    exact: true,
    path: "/sales_view",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/SalesView")),
  },
  {
    exact: true,
    path: "/picking/picking_create",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/PickingCreate")),
  },
  {
    exact: true,
    path: "/picking/picking_list",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/PickingList")),
  },
  {
    exact: true,
    path: "/picking/edit_picking/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/EditPicking")),
  },
  {
    exact: true,
    path: "/picking/picking_history",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/PickingHistory")),
  },
  {
    exact: true,
    path: "/picking/short_qty",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ShortQty")),
  },
  {
    exact: true,
    path: "/picking/view_short_qty/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ViewShortQty")),
  },
  {
    exact: true,
    path: "/picking/edit_picking/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/EditPicking")),
  },
  {
    exact: true,
    path: "/picking/picking_history",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/PickingHistory")),
  },
  {
    exact: true,
    path: "/picking/short_qty",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ShortQty")),
  },
  {
    exact: true,
    path: "/picking/view_short_qty/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ViewShortQty")),
  },
  {
    exact: true,
    path: "/picking/confirm_short_qty/:picklistNo/:productId/:orderType",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ConfirmShortQty")),
  },
  {
    exact: true,
    path: "/picking/proforma",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/Proforma")),
  },
  {
    exact: true,
    path: "/picking/view_picking/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ViewPicking")),
  },
  {
    exact: true,
    path: "/sales/view_picking_list/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ViewPickingList")),
  },
  {
    exact: true,
    path: "/DateRangePicker",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/DateRangePicker")),
  },
  {
    exact: true,
    path: "/proforma_invoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/ProformaInvoice")),
  },
  {
    exact: true,
    path: "/edit_new_invoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Edit_New_Invoice")),
  },
  {
    exact: true,
    path: "/return/add_return",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Return/AddReturn")),
  },
  {
    exact: true,
    path: "/products",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Products")),
  },
  {
    exact: true,
    path: "/products/add_product",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Products/Add_Products")),
  },
  {
    exact: true,
    path: "/products/edit/:productId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Products/Edit_Product")),
  },
  {
    exact: true,
    path: "/products/previous_pricing/:productId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Products/PreviousProduct")),
  },
  {
    exact: true,
    path: "/supplier",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Supplier/Supplier")),
  },
  {
    exact: true,
    path: "/supplier/add_supplier",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Supplier/Add_Supplier")),
  },
  {
    exact: true,
    path: "/supplier/edit_supplier/:supplierId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Supplier/Edit_Supplier")),
  },
  {
    exact: true,
    path: "/customers",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/Customers")),
  },
  {
    exact: true,
    path: "/customer/edit_customer/:customerId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/Edit_Customer")),
  },
  {
    exact: true,
    path: "/customer/contra_price/:customerId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/ContraPrice")),
  },
  {
    exact: true,
    path: "/ContraList",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/ContraList")),
  },
  {
    exact: true,
    path: "/customer/edit_customer/:customerId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/Edit_Customer")),
  },
  {
    exact: true,
    path: "/customer/contra_price/:customerId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/ContraPrice")),
  },
  {
    exact: true,
    path: "/customers/contra_price_edit/:customerId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Customers/Contra_Price_Edit")),
  },
  {
    exact: true,
    path: "/users",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Users/Users")),
  },
  {
    exact: true,
    path: "/user/edit_profile/:userId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Users/User_Profile")),
  },
  {
    exact: true,
    path: "/Brands",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Brands/Brands")),
  },
  {
    exact: true,
    path: "/Units",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Units/Units")),
  },
  {
    exact: true,
    path: "/product_category",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Product_Category")),
  },
  {
    exact: true,
    path: "/products_price_variation",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/PriceVariation/Products_Price_Variation")),
  },
  {
    exact: true,
    path: "/Customer_Credit_Facility",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/CustomerCredit/Customer_Credit_Facility")),
  },
  {
    exact: true,
    path: "/testTable",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/TableComponent")),
  },
  {
    exact: true,
    path: "/reports/customer_not_order_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/CustomerNotOrderReport")),
  },
  {
    exact: true,
    path: "/reports/mis_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/MisReport")),
  },
  {
    exact: true,
    path: "/reports/inventory_sales_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/InventorySalesReport")),
  },
  {
    exact: true,
    path: "/reports/missing_order",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/CrossOffReport")),
  },
  {
    exact: true,
    path: "/reports/sales_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/SalesRepReport")),
  },
  {
    exact: true,
    path: "/reports/profit_loss_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/ProfitLossReport")),
  },
  {
    exact: true,
    path: "/sales/newsales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/NewRSales")),
  },
  {
    exact: true,
    path: "/sales/holdList",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/HoldList")),
  },
  {
    exact: true,
    path: "/sales/shistory",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/SalesOrderHistory")),
  },
  {
    exact: true,
    path: "/sales/reject_sales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/RejectSales")),
  },
  {
    exact: true,
    path: "/sales/edit_invoice/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/EditSalesInvoice")),
  },
  {
    exact: true,
    path: "/trip/Edit_delivered_invoice/:tripId/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/trip/Edit_delivered_invoice")),
  },
  {
    exact: true,
    path: "/trip_summary/print/MultipleSummaryPrint",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/trip/MultipleSummaryPrint")),
  },
  {
    exact: true,
    path: "/trip_summary/print/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/trip/SummaryPrint")),
  },
  {
    exact: true,
    path: "/reports/mis_report/print/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/trip/SummaryPrint")),
  },
  {
    exact: true,
    path: "/picking/picking_list/view/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/trip/SummaryPrint")),
  },
  {
    exact: true,
    path: "/order_summary/print/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/OrderSummaryPrint")),
  },
  {
    exact: true,
    path: "/monthsales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/MonthSalesList")),
  },
  {
    exact: true,
    path: "/delivery/route_planing",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dispatch/CreateNewManifest")),
  },
  {
    exact: true,
    path: "/delivery/route_planing/view/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dispatch/CreateManifestPrint")),
  },
  {
    exact: true,
    path: "/stock_take/history",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/stockTake/StockTakeHistory")),
  },
  {
    exact: true,
    path: "/products/show_history_of_stock_take_list/:stockId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/stockTake/StockTakeHistoryList")),
  },
  {
    exact: true,
    path: "/stock_take/stock_take_list",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/stockTake/StockTakeList")),
  },
  {
    exact: true,
    path: "/stock_take/start_stock_take",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/stockTake/StartStockTake")),
  },
  {
    exact: true,
    path: "/purchases/purchases_order",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchasesOrder")),
  },
  {
    exact: true,
    path: "/purchases/purchases_grn",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchasesHistory")),
  },
  {
    exact: true,
    path: "/purchases/add",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchasesAddFrom")),
  },
  {
    exact: true,
    path: "/purchases/edit_po/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/EditPurchasesFrom")),
  },
  {
    exact: true,
    path: "/purchases/view/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchaseViewPrint")),
  },
  {
    exact: true,
    path: "/purchases/view_grn/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchaseHistoryViewPrint")),
  },
  {
    exact: true,
    path: "/purchases/add_grn/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/AddPurchasesGRN")),
  },
  {
    exact: true,
    path: "/account/push_sage",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/PushSage")),
  },
  {
    exact: true,
    path: "/account/push_invoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/AllPushInvoice")),
  },
  {
    exact: true,
    path: "/account/payments",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/PaymentProcess")),
  },
  {
    exact: true,
    path: "/account/customer_accounts",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/CustomerAccounts")),
  },
  {
    exact: true,
    path: "/account/supplier_ledger",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/SupplierLedger")),
  },
  {
    exact: true,
    path: "/account/payment_ladger",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/PaymentLadger")),
  },
  {
    exact: true,
    path: "/account/my_ledger",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/MyLadger")),
  },
  {
    exact: true,
    path: "/Promotions/Promos",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotions/Promos")),
  },
  {
    exact: true,
    path: "/Promotions/Create_similar_promo/:id",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotions/Create_similar_promo")),
  },
  {
    exact: true,
    path: "/Promotions/Add_Promos",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotions/Add_Promos")),
  },
  {
    exact: true,
    path: "/Promotions/Edit_Promos",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotions/Edit_Promos")),
  },
  {
    exact: true,
    path: "/Promotions/Edit_Promos/:id",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotions/Edit_Promos")),
  },
  // {
  //   exact: true,
  //   path: "/slider_settings",
  //   layout: DashboardLayout,
  //   Guard: false,
  //   component: lazy(() => import("src/components/settings/Slider_settings")),
  // },
  // {
  //   exact: true,
  //   path: "/Catalogue",
  //   layout: DashboardLayout,
  //   Guard: false,
  //   component: lazy(() => import("src/catalogue/Catalogue")),
  // },
  {
    exact: true,
    path: "/sales/Epos",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/views/Dashboard/Sales/Epos")),
  },
  {
    exact: true,
    path: "/sales/epos_sales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/EposSales")),
  },
  {
    exact: true,
    path: "/dashboard/NewSales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/NewSales")),
  },
  {
    exact: true,
    path: "/dashboard/DeliveredInvoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/DeliveredInvoice")),
  },
  {
    exact: true,
    path: "/dashboard/SalesOrder",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/SaleOrder")),
  },
  {
    exact: true,
    path: "/dashboard/OrderAccepted",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/OrderAccepted")),
  },
  {
    exact: true,
    path: "/dashboard/picklistGenerated",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/PicklistGenerated")),
  },
  {
    exact: true,
    path: "/dashboard/PickingConfirm",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/PickingConfirm")),
  },
  {
    exact: true,
    path: "/dashboard/TopSales",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/TopSales")),
  },
  {
    exact: true,
    path: "/dashboard/MaxValueOrder",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/MaxValueOrder")),
  },
  {
    exact: true,
    path: "/dashboard/ManifestGenerated",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/ManifestGenerated")),
  },
  {
    exact: true,
    path: "/dashboard/DeliveryConfirmed",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/dashboard/DeliveryConfirmed")),
  },
  {
    exact: true,
    path: "/account/product_ledger",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/ProductLadger")),
  },
  {
    exact: true,
    path: "/payments/view_product_ledger/:productId/:startDate/:endDate/:orderType",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/ProductLadgerView")),
  },
  {
    exact: true,
    path: "/returns/view/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Return/ReturnListPrint")),
  },
  {
    exact: true,
    path: "/reports/lat_long_report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/OrderLocationReport")),
  },
  {
    exact: true,
    path: "/new_sales/invoice/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/NewSalesInvoice")),
  },
  {
    exact: true,
    path: "/sales/single_view_picking_list/:picklistNo",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/picking/SingleViewPickinglist")),
  },
  {
    exact: true,
    path: "/purchaseOrder/invoice/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/purchases/PurchaseOrderInvoice")),
  },
  {
    exact: true,
    path: "/edit/proforma/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/proforma/EditProforma")),
   
  },
  {
    exact: true,
    path: "/Settings/Registration",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Settings/Registration")),
  },
  {
    exact: true,
    path: "/sales/Common_Invoice",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/Common_Invoice")),
  },
  {
    exact: true,
    path: "/Temp",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Temp")),
  },
  {
    exact: true,
    path: "/storepdf/:orderId",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/nsales/NewFile")),
  },
  {
    exact: true,
    path: "/payments/payment_allocation/:customer_id",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/account/PaymentAllocation")),
  },
  {
    exact: true,
    path: "/reports/Cashier_Report",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/reports/Cashier_Report")),
  },
  {
    exact: true,
    path: "/sales/Order_Receipt_sticker",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/Order_Receipt_sticker")),
  },
  {
    exact: true,
    path: "/product/price_sticker",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Master/Products")),
  },
  {
    exact: true,
    path: "/Promotion_Sale_slip",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Promotion_Sale_slip")),
  },
  {
    exact: true,
    path: "/sales/InventoryReport",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/Inventory_Report")),
  },
  {
    exact: true,
    path: "/sales/IncompleteOrderList",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/IncompleteOrderList")),
  },
  {
    exact: true,
    path: "/sales/Quick_Order",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/sales/Quick_Order")),
  },
  {
    exact: true,
    path: "/Invoice_Format",
    layout: DashboardLayout,
    Guard: false,
    component: lazy(() => import("src/components/Invoice_Format")),
  },
];

